export default __webpack_public_path__ + "static/media/bars-solid.b0a76220.svg";